module.exports = {
  apiKey: "AIzaSyAQwrYono0id_y2rUrxtXk8022qZqcvGNM",
  authDomain: "redirect-app-io.firebaseapp.com",
  projectId: "redirect-app-io",
  storageBucket: "redirect-app-io.appspot.com",
  messagingSenderId: "1037734438811",
  appId: "1:1037734438811:web:d6fc0dc0c43074dd53e33e",
  measurementId: "G-EHDKYMD4J4"
};
